window.myLocalStorage = {
  getItem(key) {
    // get the parsed value of the given key
    const currentCityPyld = window.localStorage.getItem(key);
    let result = '';

    if (currentCityPyld && /^[\],:{}\s]*$/.test(currentCityPyld.replace(/\\["\\\/bfnrtu]/g, '@').
replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
      result = JSON.parse(currentCityPyld);
    } else {
      window.localStorage.removeItem(key);
    }
      
    // if the key has value
    if(result){ 
        
        // if the entry is expired
        // remove the entry and return null
        if(result.expireTime <= Date.now()){
            window.localStorage.removeItem(key);
            return null;
        }  
        
        // else return the value
        return result.data;
    }
    
    // if the key does not have value
    return null;
  },
  
  // add an entry
  // default expiry is 30 days in milliseconds
  setItem(key, value, maxAge = 30 * 60 * 60 * 1000) {
     // store the value as object
     // along with expiry date
      let result  = {
        data : value
     }
     
     if(maxAge){
       // set the expiry 
       // from the current date
       result.expireTime = Date.now() + maxAge;
     }
     
     // stringify the result
     // and the data in original storage
     window.localStorage.setItem(key, JSON.stringify(result));
  },
  
  // remove the entry with the given key
  removeItem(key) {
    window.localStorage.removeItem(key);
  },
  
  // clear the storage
  clear() {
    window.localStorage.clear();
  }
};

/**
 * Guard de ciudad para /cart/add.
 *
 * El filtrado por ciudad del tema es solo visual (display:none / .hide), así que
 * cualquier camino que esquive el CSS (URL con ?variant=, "Volver a pedir",
 * sugerencias, teclado) mete al carrito una variante de otra ciudad. Este guard
 * es el único punto de validación real: bloquea el add cuando la variante
 * pertenece a una ciudad distinta a la seleccionada.
 *
 * La verdad la da la opción "Bodegas" del propio producto, no una lista de
 * settings: así quedan cubiertas también las bodegas que nunca se agregaron a los
 * settings (Fontibon, SIN LOCATION), que antes se colaban sin bloqueo.
 * Los productos sin esa opción no se tocan.
 */
var BODEGA_OPTION_NAME = 'Bodegas';

var CITY_MISMATCH_MESSAGE =
  'Este producto pertenece a otra ciudad. Cambia la ciudad de envío en la parte superior para agregarlo.';

/**
 * Comparación insensible a mayúsculas y a espacios sobrantes: el catálogo tiene
 * valores que no respetan el casing (ej. "suba-Bogota" vs "Suba-Bogota"), y esas
 * variantes se colaban sin bloqueo.
 */
function normalizeCity(value) {
  return String(value == null ? '' : value).replace(/\s+/g, ' ').trim().toLowerCase();
}

/** Posición (1-based) de la opción "Bodegas" en un producto, o 0 si no la tiene. */
function getBodegaOptionPosition(parsedProductJson) {
  var product = parsedProductJson.product || {};
  var optionsWithValues = parsedProductJson.options_with_values || product.options_with_values;

  if (optionsWithValues) {
    for (var i = 0; i < optionsWithValues.length; i++) {
      if (normalizeCity(optionsWithValues[i].name) === normalizeCity(BODEGA_OPTION_NAME)) {
        return optionsWithValues[i].position || i + 1;
      }
    }

    return 0;
  }

  // Fallback: `product | json` expone options como lista de nombres
  var optionNames = product.options || [];

  for (var j = 0; j < optionNames.length; j++) {
    if (normalizeCity(optionNames[j]) === normalizeCity(BODEGA_OPTION_NAME)) {
      return j + 1;
    }
  }

  return 0;
}

/** Busca el valor de la opción "Bodegas" de una variante en los data-product-json de la página. */
function getBodegaFromProductJson(variantId) {
  var productJsonElements = document.querySelectorAll('[data-product-json]');

  for (var i = 0; i < productJsonElements.length; i++) {
    try {
      var parsed = JSON.parse(productJsonElements[i].innerHTML);
      var position = getBodegaOptionPosition(parsed);

      if (!position) {
        continue; // este producto no está segmentado por bodega
      }

      var variants = (parsed.product || {}).variants || [];

      for (var j = 0; j < variants.length; j++) {
        if (String(variants[j].id) === String(variantId)) {
          return variants[j]['option' + position];
        }
      }
    } catch (e) {
      // JSON inválido en ese bloque: seguimos con el siguiente
    }
  }

  return null;
}

/**
 * true cuando la variante pertenece a una bodega distinta a la ciudad seleccionada.
 * bodega es opcional: los formularios estáticos la declaran en data-city-variant
 * (vía el snippet bodega-variant) para no depender del data-product-json.
 */
window.isForeignCityVariant = function (variantId, bodega) {
  var selectedCity = myLocalStorage.getItem('ciudadVarianteFinal');

  if (!selectedCity) {
    return false; // sin ciudad elegida todavía, no bloqueamos nada
  }

  var variantBodega = normalizeCity(bodega || getBodegaFromProductJson(variantId));

  if (!variantBodega) {
    return false; // producto sin opción de bodega
  }

  return variantBodega !== normalizeCity(selectedCity);
};

/** Corta el evento si el form apunta a una variante de otra ciudad. */
function blockForeignCityAdd(event, form) {
  if (!form) {
    return;
  }

  var action = form.getAttribute('action') || form.action || '';

  if (String(action).indexOf('/cart/add') === -1) {
    return;
  }

  var idField = form.querySelector('[name="id"]');

  if (!idField) {
    return;
  }

  if (!window.isForeignCityVariant(idField.value, form.getAttribute('data-city-variant'))) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();
  console.warn('[locations] Add bloqueado: variante ' + idField.value + ' es de otra ciudad');
  alert(CITY_MISMATCH_MESSAGE);
}

// Ambos en captura, para correr antes de los handlers de theme.js (delegados, en burbuja).
// theme.js agrega al carrito desde el CLICK de [data-action="add-to-cart"] y hace
// preventDefault, así que el submit solo cubre el fallback sin JS: hacen falta los dos.
document.addEventListener('click', function (event) {
  var target = event.target && event.target.closest
    ? event.target.closest('[data-action="add-to-cart"], button[type="submit"]')
    : null;

  if (!target) {
    return;
  }

  blockForeignCityAdd(event, target.closest('form'));
}, true);

document.addEventListener('submit', function (event) {
  blockForeignCityAdd(event, event.target);
}, true);

/**
 * NUEVO: Busca, dentro del JSON del producto actual (si existe en la página),
 * la variante cuyo option1/title coincide con el valor de ciudad seleccionado.
 * Retorna el ID de la variante o null si no aplica / no se encuentra.
 */
function getMatchingVariantIdForCity(cityVariantValue) {
  var productJsonElement = document.querySelector('[data-product-json]');

  if (!productJsonElement) {
    return null; // No estamos en una página de producto
  }

  try {
    var parsed = JSON.parse(productJsonElement.innerHTML);
    var productData = parsed.product;

    if (!productData || !productData.variants || !productData.variants.length) {
      return null;
    }

    var matchingVariant = productData.variants.find(function (v) {
      return v.option1 === cityVariantValue || v.title === cityVariantValue;
    });

    if (matchingVariant) {
      return matchingVariant.id;
    } else {
      console.warn('[locations] No se encontró variante para la ciudad "' + cityVariantValue + '" en el producto ' + productData.id + '. Variantes disponibles:', productData.variants.map(function(v){ return v.option1 || v.title; }));
      return null;
    }
  } catch (e) {
    console.error('[locations] Error al parsear el JSON del producto para hacer match de variante', e);
    return null;
  }
}

/**
 * Variante que la página está mostrando ahora mismo: la de la URL si viene, y
 * si no la que el formulario dejó seleccionada, que es lo que Shopify sirvió.
 * Se lee del formulario y no del primer elemento del JSON porque Shopify sirve
 * la primera variante DISPONIBLE, que no siempre es la primera de la lista.
 */
function getActiveVariantId() {
  var fromUrl = new URL(window.location.href).searchParams.get('variant');

  if (fromUrl) {
    return String(fromUrl);
  }

  var idField = document.querySelector('form[action*="/cart/add"] [name="id"]');

  return idField && idField.value ? String(idField.value) : null;
}

/**
 * Deja la ficha de producto en la variante de la ciudad guardada.
 *
 * Warehouse 3.0.1 lograba esto de rebote: clickCity() dispara un click sobre el
 * swatch de la bodega y el theme.js del tema reaccionaba seleccionando esa
 * variante. Warehouse 7 eliminó por completo el manejo de .block-swatch — su
 * theme.js no lo menciona ni una vez — y movió la selección de variante al
 * custom element <variant-picker>, que este markup no emite. El click sigue
 * ocurriendo y ya no lo escucha nadie, así que la ficha se quedaba siempre en
 * la primera variante mientras la cabecera anunciaba otra ciudad: precio, stock
 * y bodega de despacho equivocados, sin ninguna señal visible.
 *
 * Acá se fija por URL, que es el mismo estado final al que llegaba producción y
 * además lo resuelve el servidor, así que precio y stock llegan ya correctos.
 * Solo redirige si hace falta: si la variante activa ya es la de la ciudad no
 * hace nada, que es justamente lo que pasa cuando la bodega coincide con la
 * primera variante del producto.
 */
function syncVariantToStoredCity() {
  var bodega = myLocalStorage.getItem('ciudadVarianteFinal');

  if (!bodega) {
    return; // Todavía no eligió ciudad: el popup se encarga
  }

  var targetVariantId = getMatchingVariantIdForCity(bodega);

  if (!targetVariantId) {
    return; // No es ficha de producto, o el producto no se vende en esa bodega
  }

  if (String(targetVariantId) === getActiveVariantId()) {
    return; // Ya estamos en la variante correcta
  }

  var url = new URL(window.location.href);
  url.searchParams.set('variant', targetVariantId);
  window.location.replace(url.href); // replace: no ensucia el historial
}

// Delegado: el select #ciudad lo inyecta la sección popups, que se parsea después de este script
jQuery(document).on('change', '#ciudad', function() {
  if (jQuery("#ciudad option[value=selectionKey]").attr('selected', 'selected')) {
    var selectedVariantValue = $("#ciudad").val();

    myLocalStorage.setItem('ciudadVarianteFinal', selectedVariantValue);
    myLocalStorage.setItem('ciudadCiudadFinal', $( "#ciudad option:selected" ).text());

    // NUEVO: si estamos en una página de producto, calculamos la URL de destino
    // apuntando a la variante correspondiente a la nueva ciudad
    var targetUrl = null;
    var matchingVariantId = getMatchingVariantIdForCity(selectedVariantValue);

    if (matchingVariantId) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', matchingVariantId);
      // NUEVO: rompe cualquier coincidencia con una respuesta ya precargada
      // (Speculation Rules API de Shopify / instant.page), forzando siempre
      // un fetch fresco al servidor en vez de reutilizar una versión en caché
      url.searchParams.set('_r', Date.now());
      targetUrl = url.href;
    }

    clearcart(targetUrl);
  }

});
jQuery(document).ready(function($) {
    if (!myLocalStorage.getItem('ciudadVarianteFinal')) {
      $("#modal--ciudades").attr({
        "aria-hidden": 'false' // Abre el popup
      });
    } else {
      clickCity();
      syncVariantToStoredCity();
      $("#modal--ciudades").attr({"aria-hidden": 'true'});
      if (!myLocalStorage.getItem('modal--ciudad')) {
        $("#modal--imagen").attr({
          "aria-hidden": 'false' // Abre el popup
        });
      } else {
        $("#modal--imagen").attr({
          "aria-hidden": 'true' // Cierra el popup
        });
      }
      
    }  
  });
  function abrirCoberturas() {
    $("#modal--ciudades").attr({
      "aria-hidden": 'false' // Abre el popup
    });
  }
  function cerrarCoberturas() {
    $("#modal--ciudades").attr({
      "aria-hidden": 'true' // Cierra el popup
    });
    myLocalStorage.setItem('ciudadVarianteFinal', 'Minorista', 1 * 60 * 60 * 1000);
    myLocalStorage.setItem('ciudadCiudadFinal', 'Medellín', 1 * 60 * 60 * 1000);
    clearcart();
  }
  function clickCity() {
    var localizacion = myLocalStorage.getItem('ciudadVarianteFinal');
    var ref_this = $("w3-button").find(localizacion);
    if (ref_this) {
      $('.' + localizacion).trigger('click');
      $('.product-item.w3-button.' + localizacion).css('display', 'block');
    }
  }
  function openCity(cityName) {
    var target = document.getElementById(cityName);

    if (!target) {
      return;
    }

    // Solo los .city del MISMO producto. clickCity() dispara un click por cada
    // producto de la grilla, así que ocultar los .city de toda la página dejaba
    // visible un único producto y el resto sin precio ni botón de agregar.
    var siblings = target.parentNode.querySelectorAll(".city");

    for (var i = 0; i < siblings.length; i++) {
      siblings[i].style.display = "none";
    }

    target.style.display = "block";
  }
  /**
   * MODIFICADO: ahora acepta un parámetro opcional targetUrl.
   * Si se provee, redirige ahí (con location.replace, para no ensuciar
   * el historial) después de limpiar el carrito.
   * Si no, mantiene el comportamiento original (recargar la misma URL).
   */
  function clearcart(targetUrl) {
  // Redirigimos DESPUÉS de que /cart/clear.js responda. Con el setTimeout de 300ms
  // anterior, en redes lentas la página recargaba con el carrito viejo y la ciudad nueva.
  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    data: '',
    dataType: 'json',
    success: function() {
      if (window.Shopify && typeof Shopify.clear === 'function') {
        Shopify.clear();
      }
    }
  }).always(function() {
    window.location.replace(targetUrl || window.location.href);
  });
}

if (window.location.pathname === '/') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Suba-Bogota') {
    window.open("/pages/bogota", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Bucaramanga-Concordia') {
    window.open("/pages/bucaramanga", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Barranquilla') {
    window.open("/pages/barranquilla", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Bucaramanga-Concordia') {
    window.open("/pages/bucaramanga", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Minorista') {
    window.open("/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Campo-Azul-Vegas') {
    window.open("/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}





if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Rionegro') {
    window.open("/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Barranquilla') {
    window.open("/pages/barranquilla", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Suba-Bogota') {
    window.open("/pages/bogota", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Minorista') {
    window.open("/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Campo-Azul-Vegas') {
    window.open("/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}





if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Rionegro') {
    window.open("/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Barranquilla') {
    window.open("/pages/barranquilla", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Suba-Bogota') {
    window.open("/pages/bogota", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Minorista') {
    window.open("/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Campo-Azul-Vegas') {
    window.open("/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}





if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Rionegro') {
    window.open("/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Bucaramanga-Concordia') {
    window.open("/pages/bucaramanga", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Barranquilla') {
    window.open("/pages/barranquilla", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Suba-Bogota') {
    window.open("/pages/bogota", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Minorista') {
    window.open("/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Campo-Azul-Vegas') {
    window.open("/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}





if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Rionegro') {
    window.open("/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Bucaramanga-Concordia') {
    window.open("/pages/bucaramanga", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

function ordenar(){
setTimeout(function(){ 
 window.location.href = window.location.href;
}, 300);
}


  $('.header__action-item--locale .header__action-item-content .locale-selector__value').text(myLocalStorage.getItem('ciudadCiudadFinal'));
  $('#ciudadtooltip').text(myLocalStorage.getItem('ciudadCiudadFinal'));